import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c392aa06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-content" }
const _hoisted_2 = { class: "part-left" }
const _hoisted_3 = { class: "name-block" }
const _hoisted_4 = { class: "main-info" }
const _hoisted_5 = { class: "other-info" }
const _hoisted_6 = { class: "part-right" }
const _hoisted_7 = { class: "main-info" }
const _hoisted_8 = { class: "other-info" }
const _hoisted_9 = { class: "action-cntr" }
const _hoisted_10 = { class: "port-list-filters cm-ui-mb15" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  class: "port-list-tip-count",
  style: {"color":"var(--cm-color-primary)"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "cm-align-center",
  style: {"cursor":"pointer"}
}
const _hoisted_15 = {
  t: "1779073855974",
  style: {"color":"#f0a443","font-weight":"bold","font-size":"17px","margin-right":"4px"},
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6522",
  width: "17",
  height: "17"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M465.94 321.48a63.67 63.67 0 0 0-16 49l19.55 186.86a43.74 43.74 0 0 0 87 0l19.55-186.86a63.52 63.52 0 0 0-15.91-49c-23.93-26.63-70.13-26.58-94.19 0zM513.05 627.4a59 59 0 1 0 59 59 59.09 59.09 0 0 0-59-59z",
  fill: "#f0a443",
  "p-id": "6523"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M513 65.34C266.31 65.34 65.65 266 65.65 512.7S266.31 960.05 513 960.05 960.35 759.39 960.35 512.7 759.69 65.34 513 65.34z m0 842.16c-217.7 0-394.8-177.1-394.8-394.8S295.3 117.9 513 117.9 907.8 295 907.8 512.7 730.7 907.5 513 907.5z",
  fill: "#f0a443",
  "p-id": "6524"
}, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { style: {"color":"#f0a443"} }
const _hoisted_20 = { class: "cm-ui-bold-txt" }

import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  PortListDrawerService,
  QueryParams,
  PortItem,
  BlockParams,
  BlockPortItem
} from './port-list-drawer.service'
import { TableDataRowState, TableState } from '@/services/table-memory-pagination'
import type { TerminalItem } from '../../terminal-view.service'
import { ElMessage } from 'element-plus'
import { PermissionFe } from '@/services/service-permission.service'
import UnauthorizedTooltip from '@/views/dashboard/_components/unauthorized-tooltip/unauthorized-tooltip.vue'
import CmTableSelectionTipBar from '@/views/dashboard/_components/cmtable-selection-tip-bar/cmtable-selection-tip-bar.vue'
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status'
import LoadingBtn from '@/views/dashboard/manage/port-manage/_components/loading-btn/loading-btn.vue'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import { login_status } from '@/views/dashboard/response-manage/response-handle/types'
import { getRiskPortDisplayText } from '@/utils/port-risk-display'

enum SELECT_TYPE {
  APPOINT_PORT = 0,
  ALL_PORT = 1
}


export default /*#__PURE__*/_defineComponent({
  __name: 'port-list-drawer',
  props: {
    device: { default: () => ({}) as TerminalItem },
    refreshApi: {},
    hasPermission: { type: Boolean, default: false },
    riskType: {},
    showDeviceInfo: { type: Boolean, default: true }
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, te, locale } = useI18n()
const injector = useReflectiveInjector([PortListDrawerService])
const service = injector.get(PortListDrawerService)

const tableRef = ref<{ getList: () => Promise<unknown> } | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const listForm = reactive<QueryParams>({
  device_id: props.device.device_id,
  page: 1,
  limit: 20,
  asc: true,
  sort: 'port_num',
  is_risk_port: props.riskType || undefined,
  key_word: '',
  useMemory: false
})

const viewData = ref({
  tableData: [] as TableDataRowState<PortItem>[],
  state: {} as TableState<TableDataRowState<PortItem>>,
  total: 0,
})

const lastCmSelection = ref<TableDataRowState<PortItem>[]>([])
const syncingFromService = ref(false)

function riskPortListRowDetail (row: PortItem) {
  const st = row.system_type ?? props.device?.system_type
  return getRiskPortDisplayText(t, te, row.port_num, st, row.risk_detail)
}

function isDisabled() {
  return props.device.auth_status !== TerminalAuthStatus.normal || props.device.system_type === TerminalType.linux
}

service.isDisabled = isDisabled

function syncCmTableSelectionFromService() {
  const elTable = (tableRef.value as any)?.tableRef
  if (!elTable) return
  syncingFromService.value = true
  elTable.clearSelection()
  viewData.value.tableData.forEach((row) => {
    if (row.$selected) {
      elTable.toggleRowSelection(row, true)
    }
  })
  lastCmSelection.value = viewData.value.tableData.filter((r) => r.$selected)
  nextTick(() => {
    syncingFromService.value = false
  })
}

function onChangeSelected(selection: TableDataRowState<PortItem>[]) {
  if (syncingFromService.value) {
    lastCmSelection.value = selection.slice()
    return
  }
  const prev = new Set(lastCmSelection.value.map((r) => `${r.port_num}-${r.protocol}`))
  const curr = new Set(selection.map((r) => `${r.port_num}-${r.protocol}`))
  let toggled: TableDataRowState<PortItem> | undefined
  for (const r of selection) {
    const k = `${r.port_num}-${r.protocol}`
    if (!prev.has(k)) {
      toggled = r
      break
    }
  }
  if (!toggled) {
    for (const r of lastCmSelection.value) {
      const k = `${r.port_num}-${r.protocol}`
      if (!curr.has(k)) {
        toggled = r
        break
      }
    }
  }
  if (toggled) {
    service.mergeSelectedData(service.getSelectedData(), toggled)
  } else {
    service.mergeSelectedData(selection)
  }
  pullServiceState()
}

function pullServiceState() {
  const state = service.getViewState()
  viewData.value.state = state
  viewData.value.tableData = state.data.list
  viewData.value.total = state.data.total
  nextTick(syncCmTableSelectionFromService)
}

/** 与 ScanReport 的 dataFormate 一致：保持行引用，仅同步「全选端口」下的 $selected（不可与 `{ ...item }` 新对象并用 TableMemoryPagination） */
function listDataFormate(rows: TableDataRowState<PortItem>[] = []) {
  const selectAllPorts = service.getViewState().selectAll
  for (const row of rows) {
    if (selectAllPorts && !isDisabled()) {
      row.$selected = true
    }
  }
  return rows
}

function tipBarSelectedCount() {
  if (viewData.value.state.selectAll) return viewData.value.state.selectCount
  return viewData.value.tableData.filter((r) => r.$selected).length
}

/** 本页全选：选中当前页全部可选行；本页反选：逐行切换 */
function handleTipSelect(type: 'all' | 'reverse') {
  const enabled = viewData.value.tableData.filter((r) => !isDisabled())
  if (type === 'all') {
    service.mergeSelectedData(enabled)
  } else {
    for (const r of enabled) {
      service.mergeSelectedData(service.getSelectedData(), r)
    }
  }
  pullServiceState()
}

function pageSelectAllChecked(rows: TableDataRowState<PortItem>[]) {
  const enabled = rows.filter((r) => !isDisabled())
  return enabled.length > 0 && enabled.every((r) => r.$selected)
}

function pageSelectAllIndeterminate(rows: TableDataRowState<PortItem>[]) {
  const enabled = rows.filter((r) => !isDisabled())
  return enabled.some((r) => r.$selected) && !enabled.every((r) => r.$selected)
}

function handlePageSelectAllHeader(rows: TableDataRowState<PortItem>[], checked: boolean) {
  const enabled = rows.filter((r) => !isDisabled())
  if (checked) {
    service.mergeSelectedData(enabled)
  } else {
    service.mergeSelectedData([])
  }
  pullServiceState()
}

watch(
  () => props.device.device_id,
  (nv, lv) => {
    if (nv && nv !== lv) {
      listForm.device_id = nv
      nextTick(() => void refreshList())
    }
  }
)

async function listApi(params: Record<string, unknown>) {
  if (!listForm.device_id) {
    return { list: [] as PortItem[], total: 0 }
  }
  Object.assign(listForm, {
    page: params.page,
    limit: params.limit
  })
  if (params.sort !== undefined) {
    listForm.sort = params.sort as string
  }
  if (params.asc !== undefined) {
    listForm.asc = params.asc as boolean
  }
  await service.refresh(
    {
      ...listForm,
      is_risk_port: listForm.is_risk_port || undefined,
    },
  )
  pullServiceState()
  return {
    list: viewData.value.tableData,
    total: viewData.value.total
  }
}

const tableOpt = computed((): TableOpt => {
  void locale.value
  void viewData.value.state.selectAll
  return {
    selection: false,
    rowKey: ((row: PortItem) => `${row.port_num}-${row.protocol || ''}`) as unknown as TableOpt['rowKey'],
    path: 'list',
    totalPath: 'total',
    height: '100%',
    usePagination: false,
    disableScrollLoad: false,
    showTip: false,
    bodyStyle: 'height: 100%;padding: 10px 16px 16px',
    containerOpt: { style: { flex: '1', minHeight: 0, overflow: 'hidden' } },
    columns: [
      {
        prop: '__sel',
        label: '',
        width: 52,
        columnOpt: { fixed: 'left', align: 'center' }
      },
      {
        prop: 'port_num',
        label: t('portManage.portNum'),
        columnOpt: { sortable: 'custom', minWidth: 100 }
      },
      {
        prop: 'protocol',
        label: t('ipAccessEvent.protocol'),
        width: 90,
        columnOpt: { sortable: 'custom' }
      },
      {
        prop: 'is_known_risk',
        label: t('portManage.riskRef'),
        columnOpt: { minWidth: 120 }
      },
      {
        prop: 'process_name',
        label: t('portManage.listenProcess'),
        columnOpt: { sortable: 'custom', minWidth: 120 }
      },
      {
        prop: 'bind_ip',
        label: t('portManage.bindIp'),
        columnOpt: { minWidth: 120 }
      },
      {
        prop: '_action',
        label: t('portManage.action'),
        width: 100,
        columnOpt: { fixed: 'right' }
      },
    ]
  }
})

async function getData() {
  await nextTick()
  await refreshList()
}

function doBlock(params: BlockParams) {
  service.doPortcontrolTerminalBlockedRulesSave(params).then(async () => {
    ElMessage.success(t('portManage.blockSuccess'))
    await getData()
    emit('refresh')
  }).catch(() => {
    ElMessage.error(t('portManage.blockFailed'))
  })
}

function addBatchBlock() {
  const params: BlockParams = {
    device_id: props.device.device_id,
    select_type: SELECT_TYPE.APPOINT_PORT,
    port_list: []
  }
  if (viewData.value.state.selectAll) {
    params.select_type = SELECT_TYPE.ALL_PORT
  } else {
    params.port_list = service.getSelectedData().map((item) => item.port_num)
  }
  doBlock(params)
}

function addBlock(port: number) {
  const params: BlockParams = {
    device_id: props.device.device_id,
    select_type: SELECT_TYPE.APPOINT_PORT,
    port_list: [port]
  }
  doBlock(params)
}

function handleCheckbox(row: TableDataRowState<PortItem>) {
  service.mergeSelectedData(service.getSelectedData(), row)
  pullServiceState()
}

function handleAuthSuccess() {
  emit('refresh')
}

const refreshPort = async () => {
  await getData()
}

const headLoginStatus = computed(() => props.device.login_status ?? login_status.online)

function handleSearch() {
  listForm.page = 1
  nextTick(() => void refreshList())
}

function handleBatchBlockPort() {
  addBatchBlock()
}

function handleBlockPort(port: number) {
  addBlock(port)
}

async function selectAll() {
  listForm.page = 1
  listForm.useMemory = false
  service.selectAll()
  pullServiceState()
  await getData()
}

async function selectCancel() {
  listForm.useMemory = false
  service.cancelSelectAll()
  pullServiceState()
  await getData()
}

function calcSelectAllScopeDisabled() {
  if (viewData.value.total && !viewData.value.state.selectAll && !isDisabled()) {
    return false
  }
  return true
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    modelValue: listForm,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listForm) = $event)),
    "table-opt": tableOpt.value,
    api: listApi,
    "data-formate": listDataFormate,
    "page-option": { pageNumName: 'page', pageSizeName: 'limit' },
    "first-loading": true,
    onChangeSelected: onChangeSelected
  }, {
    header: _withCtx(() => [
      _withDirectives(_createVNode(TerminalHead, {
        class: "port-list-drawer-terminal-head",
        "system-type": _ctx.device.system_type ?? 1,
        "login-status": headLoginStatus.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.device.computer_name || '--'), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.device.system_name || '--'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.device.user_mark || '--'), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.device.group_name || '--'), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["system-type", "login-status"]), [
        [_vShow, _ctx.showDeviceInfo]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_select, {
            modelValue: listForm.is_risk_port,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((listForm.is_risk_port) = $event)),
            class: "cm-ui-mr10",
            size: "small",
            clearable: "",
            placeholder: _ctx.$t('portManage.riskRef'),
            onChange: handleSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('portManage.risk'),
                value: 1
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('portManage.unknown'),
                value: 2
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_input, {
            modelValue: listForm.key_word,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((listForm.key_word) = $event)),
            style: {"width":"220px"},
            size: "small",
            placeholder: _ctx.$t('portManage.portNum'),
            "suffix-icon": "el-icon-search",
            onChange: handleSearch
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !viewData.value.state.selectCount || _ctx.device.system_type === 2,
            size: "small",
            onClick: handleBatchBlockPort
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portManage.batchBlock')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (!_ctx.showDeviceInfo)
            ? (_openBlock(), _createBlock(LoadingBtn, {
                key: 0,
                "device-id": _ctx.device.device_id,
                disabled: !_ctx.hasPermission,
                onGetOriginData: refreshPort
              }, null, 8, ["device-id", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    "tip-bar": _withCtx(() => [
      _createVNode(CmTableSelectionTipBar, { "bar-height": 34 }, {
        summary: _withCtx(() => [
          _createVNode(_component_i18n_t, {
            keypath: "portManage.tipSelectedTerminalsTotal",
            tag: "span",
            class: "port-list-tip-bar__summary"
          }, {
            count: _withCtx(() => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(tipBarSelectedCount()), 1)
            ]),
            _: 1
          })
        ]),
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "text",
            class: "cm-btn-text",
            disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleTipSelect('all')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portManage.pageSelectAll')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "text",
            class: "cm-btn-text",
            disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleTipSelect('reverse')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.reversePage')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "text",
            class: "cm-btn-text",
            disabled: calcSelectAllScopeDisabled(),
            onClick: selectAll
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portManage.selectAllTerminals')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "text",
            class: "cm-btn-text",
            disabled: !viewData.value.tableData.some((item) => item.$selected) && !viewData.value.state.selectAll,
            onClick: selectCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.cancelSelect')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    "__sel-header": _withCtx(() => [
      _createVNode(_component_el_checkbox, {
        "model-value": pageSelectAllChecked(viewData.value.tableData),
        disabled: !viewData.value.tableData.length || viewData.value.state.selectAll || isDisabled(),
        indeterminate: pageSelectAllIndeterminate(viewData.value.tableData),
        onChange: _cache[4] || (_cache[4] = (v) => handlePageSelectAllHeader(viewData.value.tableData, !!v))
      }, null, 8, ["model-value", "disabled", "indeterminate"])
    ]),
    __sel: _withCtx(({ row }) => [
      _createVNode(UnauthorizedTooltip, {
        "permission-key": _unref(PermissionFe).port_control,
        "device-id": _ctx.device.device_id,
        "auth-status": _ctx.device.auth_status,
        onAuthSuccess: handleAuthSuccess
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            "model-value": row.$selected,
            disabled: viewData.value.state.selectAll || isDisabled(),
            onChange: () => handleCheckbox(row)
          }, null, 8, ["model-value", "disabled", "onChange"])
        ]),
        _: 2
      }, 1032, ["permission-key", "device-id", "auth-status"])
    ]),
    is_known_risk: _withCtx(({ row }) => [
      (!row.is_known_risk)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('portManage.unknown')), 1))
        : (_openBlock(), _createBlock(_component_el_popover, {
            key: 1,
            placement: "bottom-start",
            width: 380,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('portManage.risk')), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('portManage.riskLabel')), 1),
                _createTextVNode(_toDisplayString(riskPortListRowDetail(row)), 1)
              ])
            ]),
            _: 2
          }, 1024))
    ]),
    _action: _withCtx(({ row }) => [
      _createVNode(UnauthorizedTooltip, {
        "permission-key": _unref(PermissionFe).port_control,
        "device-id": _ctx.device.device_id,
        "auth-status": _ctx.device.auth_status,
        onAuthSuccess: handleAuthSuccess
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            disabled: isDisabled(),
            type: "text",
            onClick: ($event: any) => (handleBlockPort(row.port_num))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portManage.block')), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["permission-key", "device-id", "auth-status"])
    ]),
    _: 1
  }, 8, ["modelValue", "table-opt"]))
}
}

})